import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e1b2a5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<header data-v-7e1b2a5c><div class=\"welcome\" style=\"padding:0;\" data-v-7e1b2a5c><div class=\"order\" data-v-7e1b2a5c><a href=\"https://dinfo.me/onlineorder/#/home/menu/?restid=t4elkgrove\" data-v-7e1b2a5c>ORDER ONLINE</a></div><picture style=\"width:100%;height:100%;\" data-v-7e1b2a5c><source media=\"(min-width: 800px)\" srcset=\"/images/pc/banner@2x.webp, /images/pc/banner@2x.webp 2x\" data-v-7e1b2a5c><source media=\"(min-width: 450px)\" srcset=\"\n              /images/mobile/banner@2x.webp,\n              /images/mobile/banner@2x.webp 2x\n            \" data-v-7e1b2a5c><img style=\"width:100%;\" src=\"/images/mobile/banner.webp\" srcset=\"/images/mobile/banner.webp 2x\" alt=\"\" data-v-7e1b2a5c></picture></div><div class=\"des\" data-v-7e1b2a5c>a cup of tea for 清茶达人</div></header>", 1)
const _hoisted_3 = { class: "speciality section_container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "our speciality", -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { style: {"width":"100%"} }
const _hoisted_7 = ["srcset"]
const _hoisted_8 = ["srcset"]
const _hoisted_9 = ["src", "srcset"]
const _hoisted_10 = { class: "flavor section_container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "flavor MILK TEA", -1))
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { style: {"width":"100%"} }
const _hoisted_14 = ["srcset"]
const _hoisted_15 = ["srcset"]
const _hoisted_16 = ["src", "srcset"]
const _hoisted_17 = { class: "section3 section_container" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "speciality Snack", -1))
const _hoisted_19 = { class: "content" }
const _hoisted_20 = { style: {"width":"100%"} }
const _hoisted_21 = ["srcset"]
const _hoisted_22 = ["srcset"]
const _hoisted_23 = ["src", "srcset"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", null, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Address   Contact"),
    /*#__PURE__*/_createElementVNode("div", null, "8469 Elk Grove Blvd #9, Elk Grove, CA 95758"),
    /*#__PURE__*/_createElementVNode("div", null, "(916) 896-1561")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Opening Hours"),
    /*#__PURE__*/_createElementVNode("div", null, "Monday - Thursday"),
    /*#__PURE__*/_createElementVNode("div", null, "LUNCH: 11:00 am - 10:00 pm"),
    /*#__PURE__*/_createElementVNode("div", null, "Friday - Sunday:"),
    /*#__PURE__*/_createElementVNode("div", null, "LUNCH: 11:00 am - 10:00 pm")
  ])
], -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

// const imgsrc = [
//   "@/assets/mobile/1-1.webp",
//   "http://www.t4uelkgrove.com/img/list2.jpg",
//   "http://www.t4uelkgrove.com/img/list3.jpg",
//   "http://www.t4uelkgrove.com/img/list3.jpg",
// ];
// const imgsrc1 = [
//   "http://www.t4uelkgrove.com/img/list1.jpg",
//   "http://www.t4uelkgrove.com/img/list2.jpg",
//   "http://www.t4uelkgrove.com/img/list3.jpg",
//   "http://www.t4uelkgrove.com/img/list3.jpg",
//   "http://www.t4uelkgrove.com/img/list3.jpg",
// ];
// const imgsrc2 = [
//   "http://www.t4uelkgrove.com/img/list1.jpg",
//   "http://www.t4uelkgrove.com/img/list2.jpg",
//   "http://www.t4uelkgrove.com/img/list3.jpg",
// ];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, (item) => {
          return _createElementVNode("div", {
            class: "item-card",
            key: item
          }, [
            _createElementVNode("picture", _hoisted_6, [
              _createElementVNode("source", {
                media: "(min-width: 800px)",
                srcset: `/images/pc/1-${item}@2x.webp, /images/pc/1-${item}@2x.webp 2x`
              }, null, 8, _hoisted_7),
              _createElementVNode("source", {
                media: "(min-width: 450px)",
                srcset: `/images/pc/1-${item}@2x.webp, /images/pc/1-${item}@2x.webp 2x`
              }, null, 8, _hoisted_8),
              _createElementVNode("img", {
                style: {"width":"100%"},
                src: `/images/mobile/1-${item}.webp`,
                alt: "",
                srcset: `/images/mobile/1-${item}@2x.webp 2x`
              }, null, 8, _hoisted_9)
            ])
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item) => {
          return _createElementVNode("div", {
            class: "item-card",
            key: item
          }, [
            _createElementVNode("picture", _hoisted_13, [
              _createElementVNode("source", {
                media: "(min-width: 800px)",
                srcset: `/images/pc/2-${item}@2x.webp, /images/pc/2-${item}@2x.webp 2x`
              }, null, 8, _hoisted_14),
              _createElementVNode("source", {
                media: "(min-width: 450px)",
                srcset: `/images/pc/2-${item}@2x.webp, /images/pc/2-${item}@2x.webp 2x`
              }, null, 8, _hoisted_15),
              _createElementVNode("img", {
                style: {"width":"100%"},
                src: `/images/mobile/2-${item}.webp`,
                alt: "",
                srcset: `/images/mobile/2-${item}@2x.webp 2x`
              }, null, 8, _hoisted_16)
            ])
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, (item) => {
          return _createElementVNode("div", {
            class: "item-card",
            key: item
          }, [
            _createElementVNode("picture", _hoisted_20, [
              _createElementVNode("source", {
                media: "(min-width: 800px)",
                srcset: `/images/pc/3-${item}@2x.webp, /images/pc/3-${item}@2x.webp 2x`
              }, null, 8, _hoisted_21),
              _createElementVNode("source", {
                media: "(min-width: 450px)",
                srcset: `/images/pc/3-${item}@2x.webp, /images/pc/3-${item}@2x.webp 2x`
              }, null, 8, _hoisted_22),
              _createElementVNode("img", {
                style: {"width":"100%"},
                src: `/images/mobile/3-${item}.webp`,
                alt: "",
                srcset: `/images/mobile/3-${item}@2x.webp 2x`
              }, null, 8, _hoisted_23)
            ])
          ])
        }), 64))
      ])
    ]),
    _hoisted_24
  ]))
}
}

})